import { useTheme } from '@mui/material';

export const EmailSuccessIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={30} height={31} fill="none">
            <path
                fill={primaryStroke}
                d="M3.75 6.45H3v18h12.066a9.053 9.053 0 0 1-.535-1.5H4.5V11.68l9.919 7.276c.103-.53.253-1.04.445-1.533L4.5 9.82V7.95h21v4.03a9.05 9.05 0 0 1 1.5.535V6.45H3.75Zm19.5 9a5.25 5.25 0 1 1 0 10.5 5.25 5.25 0 0 1 0-10.5Zm0 12a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5Zm3.3-9.165-1.214-.88-.44.604-2.485 3.417a290.12 290.12 0 0 0-1.786-1.786l-1.06 1.06c.132.13.933.932 2.405 2.404l.62.619.515-.708 3-4.125.44-.605h.005Z"
            />
        </svg>
    );
};
